/**
 * @generated SignedSource<<f28d26d75f53707896f28eb346a20eda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoFeedbackStatus = "FEEDBACK_COMPLETED" | "FEEDBACK_DISMISSED" | "FEEDBACK_NEEDED";
import { FragmentRefs } from "relay-runtime";
export type TodoContact_todo$data = {
  readonly allTodoFeedbacks: ReadonlyArray<{
    readonly createdByActor: {
      readonly " $fragmentSpreads": FragmentRefs<"Avatar_actor">;
    } | null;
  }>;
  readonly contact: {
    readonly address: string | null;
    readonly email: string | null;
    readonly name: string | null;
    readonly phoneNumber: string | null;
  } | null;
  readonly feedbackStatus: TodoFeedbackStatus | null;
  readonly " $fragmentType": "TodoContact_todo";
};
export type TodoContact_todo$key = {
  readonly " $data"?: TodoContact_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoContact_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoContact_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoContact",
      "kind": "LinkedField",
      "name": "contact",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoFeedback",
      "kind": "LinkedField",
      "name": "allTodoFeedbacks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "createdByActor",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Avatar_actor"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "ed511b10b7c606320c77dc426fc9a211";

export default node;
